import { render } from "./GamePlayers.vue?vue&type=template&id=26117be4"
import script from "./GamePlayers.vue?vue&type=script&lang=js"
export * from "./GamePlayers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__